export const config = {
    API_BASE: window._env.API_BASE,
    BASE_URL: window._env.BASE_URL,
    GS_BUCKET_URL: window._env.GS_BUCKET_URL,
    IMG_URL: window._env.IMG_URL,
    widgetsAppUrl: window._env.widgetsAppUrl,
    tokenApiUrl: window._env.tokenApiUrl,
}
